import {JeTagType} from "src/utils/constants";
import TPEAction from "src/models/common/TPEAction";
import {SetUpTagJournalEntryModalState} from "./SetUpTagJournalEntryModalState";

export const MODAL_ACTIONS = Object.freeze({
    SET_DESCRIPTION: new TPEAction('SET_DESCRIPTION'),
    SET_ORIGINAL_DESCRIPTION: new TPEAction('SET_ORIGINAL_DESCRIPTION'),
    SET_BEAT_CLI_ROLE: new TPEAction('SET_BEAT_CLI_ROLE'),
    SET_ASSOCIATED_BASE_JE: new TPEAction('SET_ASSOCIATED_BASE_JE'),
    SET_BASE_JE_OPTIONS: new TPEAction('SET_BASE_JE_OPTIONS'),
    SET_SHOULD_FETCH_JE_TAGS: new TPEAction('SET_SHOULD_FETCH_JE_TAGS'),
    SET_SHOULD_UNTAG_JE_TAGS: new TPEAction('SET_SHOULD_UNTAG_JE_TAGS'),
    RESET_FOR_STEP: new TPEAction('RESET_FOR_STEP'),
    RESET_BASE_JE: new TPEAction('RESET_BASE_JE')
});

export function modalReducer(state: SetUpTagJournalEntryModalState, action: any): SetUpTagJournalEntryModalState {
    switch (action.type) {
        case MODAL_ACTIONS.SET_DESCRIPTION.type:
            return {
                ...state,
                jeTagDescription: action.payload
            };
        case MODAL_ACTIONS.SET_ORIGINAL_DESCRIPTION.type:
            return {
                ...state,
                originalJETagDescription: action.payload
            };
        case MODAL_ACTIONS.SET_BEAT_CLI_ROLE.type:
            return {
                ...state,
                beatCliRole: action.payload
            };
        case MODAL_ACTIONS.SET_ASSOCIATED_BASE_JE.type:
            return {
                ...state,
                associatedBaseJE: action.payload
            };
        case MODAL_ACTIONS.SET_BASE_JE_OPTIONS.type:
            return {
                ...state,
                baseJEOptions: action.payload
            };
        case MODAL_ACTIONS.SET_SHOULD_FETCH_JE_TAGS.type:
            return {
                ...state,
                shouldFetchJeTags: action.payload
            };
        case MODAL_ACTIONS.SET_SHOULD_UNTAG_JE_TAGS.type:
            return {
                ...state,
                shouldUnTagJeTags: action.payload
            };
        case MODAL_ACTIONS.RESET_FOR_STEP.type:
            return {
                ...state,
                jeTagDescription: action.payload.description,
                originalJETagDescription: action.payload.description,
                beatCliRole: action.payload.jeTagType,
                associatedBaseJE: action.payload.associatedBaseJE
            };
        case MODAL_ACTIONS.RESET_BASE_JE.type:
            return {
                ...state,
                associatedBaseJE: ''
            };
        default:
            console.warn(`No action found for ${action.type}. Returning unchanged state`)
            return state;
    }
}

